import { useContext } from 'react';
import { VerticalContext } from '../context/VerticalContext';

export function useVertical() {
  const ctx = useContext(VerticalContext);
  if (!ctx) throw new Error('useVertical must be used within a VerticalProvider');
  return ctx;
}
